import styled from 'styled-components';
import { Container, appearFromLeft } from '../style';

export const TableGrid = styled.div``;

export const Father = styled.div`


`;
export const Periodo = styled(Container)`
  font-weight: 500;
  font-size: 10px;
  line-height: 11px;
  color: #98a2b2;
  text-align: start;
  padding-left: 8px;
`;

export const TableCourse = styled(Container)`
  display: flex;
  flex: 1;
  flex-direction: column;

  color: #98a2b2;
  box-shadow: 0px 4px 8px rgba(0, 34, 102, 0.1);
  border-radius: 6px;
  background: #ffffff;
  padding: 0px 20px;
  font-weight: 500;
  font-size: 12px;
  line-height: 13px;
  color: #7a8799;
  margin-left: -15px;
  box-sizing: border-box;

  
`;

export const TableCourseT = styled(TableCourse)`
animation: ${appearFromLeft} 1s;
`;


export const TableTitle = styled(Container)`
  background: #646464;
`;

export const TableRow = styled(Container)`
  flex-direction: row;

  font-style: normal;
  color: #7a8799;
  margin: 0px;
  padding-top: 14px;
  padding-bottom: 14px;
  border-top: 0.5px solid #e8e8e8;
`;

export const TableRowHeader = styled(TableRow)`
  padding-top: 25px;
  padding-bottom: 0px;
  color: #98a2b3;
  border-top: hidden;
`;

export const TableColumn = styled(Container)`
  text-align: start;
`;

export const TableColumnCourses = styled(TableColumn)`
  min-width: 250px;
`;

export const TableColumnTitle = styled(TableColumn)`
  width: 100px;
  flex: 1;
`;

export const TableColumnTitleAlign = styled(TableColumnTitle)`
  text-align: end;
  flex: inherit;
  align-content: flex-end;

  .blue-circle{
    height: 25px;
    width: 25px;
    background-color: #4A90E2;
    border-radius: 50%;
    display: inline-block;
  }
`;

export const TableRowTitle = styled(TableRow)`
  border-top: hidden;
  padding-top: 7px;
  padding-bottom: 7px;
  flex: 0;
`;

export const TableColumnTitleCourse = styled(TableColumnTitleAlign)`
  padding-right: 9px;
`;

export const TableBody = styled(Container)``;

export const TableHeader = styled(TableGrid)`
  width: 100%;
  height: 50px;
  align-items: center;

  h4 {
    margin: 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #98a2b3;
  }
`;

//--------------
